import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import EditableField from 'components/editable-field'
import Toggle from 'components/toggle'
import { currencySymbol, formatPriceDecimals } from 'utils/format'

import styles from './deal-list-item.css'

const showCurrencySymbol = (value, currencyCode) => (_.isNil(value) ? '' : currencySymbol(currencyCode))

const getItemStyle = (editable, isOnsale) => {
  if (editable && isOnsale) {
    return { backgroundColor: '#eef9f6' }
  } else if (!isOnsale) {
    return { backgroundColor: '#fff6f6' }
  }
  return null
}

const DealListItem = CSSModules(({ currencyCode, dealErrors, deal, editable, onChange, shared }) => (
  <div
    styleName={shared ? 'deal-list-item-shared' : 'deal-list-item-normal'}
    style={getItemStyle(editable, deal.isOnsale)}
  >
    <div styleName={shared ? 'row-shared' : 'row-normal'}>
      <Relayout>
        <RelayoutItem sm="12" lg="4">
          <div styleName={shared ? 'ticket-type-shared' : 'ticket-type-normal'}>
            <EditableField
              editable={!deal.sharedAllocation && editable}
              hasError={dealErrors && dealErrors.ticketType}
              important
              onChange={e => onChange(deal.id, 'ticketType', e.target.value)}
              primary={!shared}
              value={deal.sharedAllocation ? 'Shared allocation' : deal.ticketType}
            />
            {!deal.sharedAllocation && deal.canEditOnsale &&
              <div styleName="toggle-field-small">
                <Toggle
                  checked={deal.isOnsale}
                  onChange={checked => onChange(deal.id, 'isOnsale', checked)}
                  small={shared}
                />
              </div>
            }
          </div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          {!_.isNil(deal.discountPrice) &&
            <div styleName="item">
              <EditableField
                isNumeric
                editable={editable}
                hasError={dealErrors && dealErrors.discountPrice}
                label="Ticket price"
                onChange={e => onChange(deal.id, 'discountPrice', e.target.value)}
                prefix={showCurrencySymbol(deal.discountPrice, currencyCode)}
                primary={!shared}
                value={editable ? deal.discountPrice : formatPriceDecimals(deal.discountPrice)}
              />
              <hr styleName="hr" />
            </div>
          }
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          <div styleName="item">
            <EditableField
              isNumeric
              editable={!shared && editable}
              hasError={dealErrors && dealErrors.ticketCount}
              label="Tickets sold"
              onChange={e => onChange(deal.id, 'ticketCount', e.target.value)}
              prefix={`${deal.soldTickets} /`}
              primary={!shared}
              value={deal.ticketCount}
            />
            <hr styleName="hr" />
          </div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          <div styleName="item">
            <EditableField
              label="Revenue"
              onChange={e => onChange(deal.id, 'totalPartnerShare', e.target.value)}
              prefix={showCurrencySymbol(deal.totalPartnerShare, currencyCode)}
              primary={!shared}
              value={formatPriceDecimals(deal.totalPartnerShare)}
            />
          </div>
        </RelayoutItem>
        <RelayoutItem sm="0" lg="1">
          {!deal.sharedAllocation && deal.canEditOnsale &&
            <div styleName="toggle-field">
              <Toggle
                checked={deal.isOnsale}
                onChange={checked => onChange(deal.id, 'isOnsale', checked)}
                small={shared}
              />
            </div>
          }
        </RelayoutItem>
      </Relayout>
    </div>
    {deal.sharedDeals &&
      <div
        styleName="shared-deals"
        style={getItemStyle(editable, deal.isOnsale)}
      >
        {deal.sharedDeals.map((sharedDeal, index) =>
          <DealListItem
            key={index}
            currencyCode={currencyCode}
            deal={sharedDeal}
            editable={editable}
            onChange={onChange}
            shared
          />
        )}
      </div>
    }
  </div>
), styles, { allowMultiple: true })

DealListItem.propTypes = {
  currencyCode: PropTypes.string,
  deal: PropTypes.object,
  dealErrors: PropTypes.object,
  editable: PropTypes.bool,
  shared: PropTypes.bool,
}

export default DealListItem



/** WEBPACK FOOTER **
 ** ./src/components/deal-list-item/deal-list-item.js
 **/